export default (state = {}, action) => {
  switch (action.type) {
    case "UPDATE_THEME": {
      return {
        ...state,
        style_attributes: { ...state.style_attributes, ...action.data }
      };
    }
    case "UPDATE_COMPILED_THEME": {
      return {
        ...state,
        asset_url: action.data
      };
    }
    default: {
      return state;
    }
  }
};
